import type { ProjectStories } from "@/features/Projects";

// Default stories structure when none exists
export const getDefaultStories = (): ProjectStories => ({
  epics: [],
  stories: [],
  totalStoryPoints: 0,
  totalEstimatedHours: 0,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
});

// Priority labels for display
export const PRIORITY_LABELS = {
  must_have: { label: "Must Have", color: "bg-red-100 text-red-800", priority: 1 },
  should_have: { label: "Should Have", color: "bg-yellow-100 text-yellow-800", priority: 2 },
  could_have: { label: "Could Have", color: "bg-green-100 text-green-800", priority: 3 },
  wont_have: { label: "Won't Have", color: "bg-gray-100 text-gray-800", priority: 4 },
} as const;

// Status labels for display
export const STATUS_LABELS = {
  backlog: { label: "Backlog", color: "bg-gray-100 text-gray-800" },
  in_progress: { label: "Em Progresso", color: "bg-blue-100 text-blue-800" },
  review: { label: "Em Revisão", color: "bg-yellow-100 text-yellow-800" },
  done: { label: "Concluída", color: "bg-green-100 text-green-800" },
  blocked: { label: "Bloqueada", color: "bg-red-100 text-red-800" },
} as const;

// Type labels for display
export const TYPE_LABELS = {
  feature: { label: "Feature", color: "bg-indigo-100 text-indigo-800" },
  enhancement: { label: "Melhoria", color: "bg-purple-100 text-purple-800" },
  bug: { label: "Bug", color: "bg-red-100 text-red-800" },
  technical: { label: "Técnica", color: "bg-gray-100 text-gray-800" },
} as const;

// Story points options
export const STORY_POINTS_OPTIONS = [0, 1, 2, 3, 5, 8, 13, 21, 34] as const;

// Priority options for forms
export const PRIORITY_OPTIONS = [
  { value: "must_have", label: "Must Have" },
  { value: "should_have", label: "Should Have" },
  { value: "could_have", label: "Could Have" },
  { value: "wont_have", label: "Won't Have" },
] as const;

// Status options for forms
export const STATUS_OPTIONS = [
  { value: "backlog", label: "Backlog" },
  { value: "in_progress", label: "Em Progresso" },
  { value: "review", label: "Em Revisão" },
  { value: "done", label: "Concluída" },
  { value: "blocked", label: "Bloqueada" },
] as const;

// Type options for forms
export const TYPE_OPTIONS = [
  { value: "feature", label: "Feature" },
  { value: "enhancement", label: "Melhoria" },
  { value: "bug", label: "Bug" },
  { value: "technical", label: "Técnica" },
] as const;